import authConstants from '../actiontypes/auth';

const initialState = {
  token: '',
  isAuthorized: false,
  initPage: undefined
};

function auth(state = initialState, action) {
  switch (action.type) {
    case authConstants.TOKEN_REFRESH_REQUEST:
      return { ...state };
    case authConstants.TOKEN_REFRESH_SUCCESS:
      return { ...state, token: action.token, isAuthorized: true };
    case authConstants.TOKEN_REFRESH_FAILURE:
      return { ...state, token: '', isAuthorized: false };
    case authConstants.INIT_PAGE_SET:
      return { ...state, initPage: action.payload };
    default:
      return state;
  }
}

export default auth;
